import React, { useEffect } from 'react'

type Props = {
  title: string
  icon: string
  children?: React.ReactNode
}

export const PageTitle: React.FC<Props> = ({ title, icon, children }) => {
  useEffect(() => {
    document.title = `${title} - HONDANA管理システム`
  }, [title])
  return (
    <div className="app-page-title">
      <div className="page-title-wrapper">
        <div className="page-title-heading">
          <div className="page-title-icon">
            <i className={`icon-gradient bg-primary ${icon}`} />
          </div>
          <div>{title}</div>
        </div>
        {children && <div className="page-title-actions">{children}</div>}
      </div>
    </div>
  )
}
